export default __webpack_public_path__ + "static/media/desk_preland_4.fb9e3294.jpg";